import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";

import { PackageSize, packageSize } from "@megaron/fulfillment-contracts";

export const packageSizeLabelMap: Record<PackageSize, string> = {
  small: "Gabaryt A",
  medium: "Gabaryt B",
  large: "Gabaryt C",
  custom: "Gabaryt D",
};

type Props = {
  onClose: () => void;
  onSelect: (size: PackageSize) => void;
};

export const PackageSizeDialog = ({ onClose, onSelect }: Props) => (
  <Dialog header="Wybierz gabaryt" onClose={onClose} css={{ maxWidth: "400px" }}>
    <div css={{ margin: "1rem 0" }}>Aby wygenerować etykietę, wybierz gabaryt paczki:</div>
    <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {packageSize.map((size) => (
        <Button key={size} onClick={() => onSelect(size)}>
          {packageSizeLabelMap[size]}
        </Button>
      ))}
    </div>
  </Dialog>
);
